import "@olmokit/core/forms/checkbox";
import FormsInputMaterial from "@olmokit/core/forms/input/material";
import FormsSelectMaterial from "@olmokit/core/forms/select/material";
import "@olmokit/core/forms/textarea/filled";
// import Olmoforms from "@acanto/core-olmoforms/feedback";
import { globalConf } from "@olmokit/core/data";
import Collapsable from "@olmokit/core/collapsable";
import FormsBase from "@olmokit/core/forms/base";
import Dependency from "@olmokit/core/olmoforms/dependency";
import { countryEndpoint } from "components/Form";
import { salesforceCommunication } from "components/Form";
import { $, $all, forEach, on } from "@olmokit/dom";
import "./index.scss";

/**
 * Component: FormDownload
 */
export function FormDownload() {
  console.log("FormDownload mounted.");

  const $root = $('.FormDownload:');

  FormsBase($root, ".FormDownload:form", {
    url: globalConf.cmsApiUrl + "/request/assets",
    succeded: handleSucceded,
    failed: handleFailed,
  });

  Dependency(".FormDownload:");
  const $container = $('.FormDownload: .of:country');
  const $country = $('select', $container);

  on($country, 'change', () => {  
    console.log('$country.value', $country.value);
    countryEndpoint(".FormDownload:", $country.value);
  });  

  const $files = $all('[data-file]');
  const $truename = $("[data-name='truename']", $root);
  forEach($files, (file) => {
    const data = file.getAttribute('data-file');
    on(file, 'click', () => {
      $truename.value = data;
    });
  });

  const $feedback = $(".of:feedback", $root);
  const $success = $(".of:feedback__success", $feedback);
  const $failure = $(".of:feedback__failure", $feedback);
  const areaForm = Collapsable($(".FormDownload:form"));
  const areaFeedback = Collapsable($feedback);

  /**
   * Handle succeeded
   *
   * @param {object} formData The data sent to the server
   * @param {object} instance The form instance
   * @param {object} response The server response
   */
  function handleSucceded(formData, instance, response) {
    dataLayer.push({
        ...formData,
        user_type: formData['usertype'],
        event: "form sent",
        form: "Form Download",
      });    
    toggle($success, true);
    toggle($failure, false);
    areaForm.collapse();
    areaFeedback.expand();
    salesforceCommunication(formData, "Form Download");    

    const a = document.createElement('a');
    document.body.appendChild(a);
    a.download = 'catalogue.pdf';
    a.href = response.data.url;
    a.click();    

    const $form = $('.FormDownload:form');
    $form.reset();
  }

  /**
   * Handle failed
   *
   * @param {object} formData The data sent to the server
   * @param {object} instance The form instance
   * @param {object} response The server response
   */
  function handleFailed(formData, instance, response) {
    toggle($success, false);
    toggle($failure, true);
    areaFeedback.expand();
    if (failed) failed(instance);
  }  

  function toggle(el, show) {
    el.style.display = show ? "block" : "none";
  }  

  FormsInputMaterial();
  FormsSelectMaterial();  
}
